import { Modal } from "antd";
import styled from "styled-components";

export const ContainerFormularioHistorico = styled(Modal)`
  top: 20px;

  .ant-modal-content {
    padding: 0px;
    height: 100%;
    overflow-y: auto;
  }

  .ant-modal-footer{
    margin-top: 5px;
  }
  
`;

export const HeaderFormulario = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e8e8e8;
`;

export const BodyFormulario = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
`;

export const FooterFormulario = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
`;

export const OutrosLogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 5px;
  border: 1px dashed #d9d9d9;
  background: #ffffffff;
`;

export const OutrosLogsHeader = styled.div`
  font-weight: bold;
  font-size: 13px;
  color: #333;
  padding: 10px;
`;

export const OutrosLogsBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
`;

export const SubLogList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 150px;
  overflow-y: auto;
  gap: 10px;
  padding: 0;
  border-left: 3px solid #2a6856;
  padding-left: 10px;
`;

export const SubLogItem = styled.div`
  background-color: #fff;
  border: 1px solid #9f9f9f;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .sub-log-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .sub-log-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    font-weight: 600;
  }

  .sub-log-desc {
    font-size: 13px;
    color: #4a5568;
    margin: 0;
  }

  .sub-log-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    
    button {
      cursor: pointer;
      background: transparent;
      border: none;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;
